@if (data$ | async; as data) {
  <cx-generic-link [url]="data.url" [style]="data.styleAttributes"
  [target]="getTarget(data)" [class]="data.styleClasses" [id]="data.uid" (click)="changeTab(data.styleClasses);
                 goToElement(data.uid)">
    @if (!data.icon) {
      {{ data.linkName }}
    }
    @if (data.icon && data.icon.url) {
      <cx-media [container]="data.icon">1</cx-media>
    }
  </cx-generic-link>
}